import React, { useState, useEffect } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Checkbox,
	FormControl,
	FormControlLabel,
} from "@mui/material";
// import Util from "../../validation/index";
import SearchIcon from "@mui/icons-material/Search";
import { NavLink } from "react-router-dom";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import { AiOutlineSearch } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@mui/styles";
// import { makeStyles } from "@mui/material/styles";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import NotificationPopups from "../../NotificationPopup/NotificationPopups";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import { adminGetFeeMasterList } from "../../redux/actions/adminGetFeeMasterListAction";
import { adminGetFeeDefaultValues } from "../../redux/actions/adminGetFeeDefaultValuesAction";
import { getRoleList } from "../../redux/actions/getRoleListAction";
import { adminGetFeeOperationType } from "../../redux/actions/adminGetFeeOperationTypeAction";
import { adminAddOrUpdateFee } from "../../redux/actions/adminAddOrUpdateFeeAction";

import { adminGetkycActionType } from "../../redux/actions/adminGetKycActionTypeAction";
import { adminGetKycDocumentList } from "../../redux/actions/adminGetKycDocumentListAction";
import { adminAddOrUpdateKycDocument } from "../../redux/actions/adminAddOrUpdateKycDocumentAction";
import val from "../../getThemeDetails"
// import { makeStyles, useTheme } from "@mui/material/styles";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
// import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import { adminGetCountryList } from '../../redux/actions/adminGetCountryList';
import { getDefaultCurrencyList } from "../../redux/actions/adminCurrencyListAction";
import { adminCurrencyCode } from "../../redux/actions/adminCurrencyCodeAction";

const useStyles = makeStyles((theme) => ({
	formControl: {
		// margin: theme.spacing(1),
		minWidth: 120,
		maxWidth: 300
	},
	chips: {
		display: "flex",
		flexWrap: "wrap"
	},
	chip: {
		margin: 2
	},
	noLabel: {
		// marginTop: theme.spacing(3)
	},
	table: {
		minWidth: 650
	}
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
	PaperProps: {
		style: {
			maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
			width: 250
		}
	}
};

function AdminFeeMaster() {
	const [levelList, setLevelList] = React.useState([]);
	const [operationTypeList, setOperationTypeList] = React.useState([]);

	const handleChange = ({ target: { name, value } }) => {
		// console.log("oppppeeechange", operationTypeList)
		if (name === "searchFeeUnit") {
			setSearchFeeUnit(value == "Select Fee Unit" ? "" : value);
		}
		if (name === "searchFeeName") {
			setSearchFeeName(value);
		}
		if (name === "level") {
			setLevelList(value);
		}
		if (name === "operationType") {
			setOperationTypeList(value);
		} if (name === "searchCurrency") {
			setSearchCurrency(value == "All" ? "" : value);
		}
	};

	const [searchCurrency, setSearchCurrency] = useState("");
	const [searchFeeName, setSearchFeeName] = useState("");
	const [searchFeeUnit, setSearchFeeUnit] = useState("");
	const [searchActionType, setSearchActionType] = useState("");
	const [searchDocumentName, setSerchDocumentName] = useState("");

	const [page, setPage] = useState(0);
	const [editOpen, setEditOpen] = React.useState(false);
	const [viewOpen, setViewOpen] = React.useState(false);
	const [addOpen, setAddOpen] = React.useState(false);
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [isLoading, setIsLoading] = useState(false);

	const [getFeeMasterListStatus, setGetFeeMasterListStatus] = useState(false);
	const [getFeeMasterListArray, setGetFeeMasterListArray] = useState([]);

	const [getRoleStatus, setGetRoleStatus] = useState(false);
	const [getRoleResArray, setGetRoleResArray] = useState([]);
	const [feeOperationTypeStatus, setFeeOperationTypeStatus] = useState(false);
	const [feeOperationTypeArray, setFeeOperationTypeArray] = useState([]);
	const [addOrUpdateFeeStatus, setAddOrUpdateFeeStatus] = useState(false);
	const [addOrUpdateFeeArray, setAddOrUpdateFeeArray] = useState([]);

	const [getKycActionTypeStatus, setGetGetKycActionTypeStatus] =
		useState(false);
	const [getKycActionTypeArray, setGetKycActionTypeArray] = useState([]);

	const [getKycDocumentListStatus, setGetKycDocumentListStatus] =
		useState(false);
	const [getKycDocumentListArray, setGetKycDocumentListArray] = useState([]);

	const [addOrUpdateKycDocumentStatus, setAddOrUpdateKycDocumentStatus] =
		useState(false);
	const [addOrUpdateKycDocumentArray, setAddOrUpdateKycDocumentArray] =
		useState([]);

	const [notificationOpen, setNotificationOpen] = React.useState(false);
	const [countryListArray, setCountryListArray] = useState([]);
	console.log("countryListArray", countryListArray)
	const [currencylistArray, setCurrencyListArray] = useState([]);
	console.log("currencylistArray", currencylistArray)

	const view = "view";
	const edit = "edit";

	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;
	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);


	const adminCurrencyList = useSelector(
		({ adminCurrencyList }) => adminCurrencyList
	);


	console.log("regenerateTokenRes", regenerateTokenRes);
	console.log("regenerateTokenRes", regenerateTokenRes);

	useEffect(() => {
		console.log(
			regenerateTokenRes,
			"/////////////////////////////////////////////////////"
		);
	}, [regenerateTokenRes]);
	var authToken = regenerateTokenRes.data.AuthToken;
	const classes = useStyles();
	const dispatch = useDispatch();

	const [user, setUser] = useState({
		feeId: "",
		feeName: "",
		inputRequired: "",
		feeUnit: "",
		feeTechnicalName: "",
		transactionUnit: "",
		operation: "",
		operationType: "",
		frequency: "",
		level: "",
		feeOwner: "",
		paymentBy: "",
		status: "",
		sequenceNumber: "",
		fieldAcrobatName: "",
		paymentMode: "",
		country: "",
		currency: "",
	});

	const {
		feeId,
		feeName,
		inputRequired,
		feeTechnicalName,
		feeUnit,
		transactionUnit,
		operation,
		operationType,
		frequency,
		level,
		feeOwner,
		paymentBy,
		status,
		sequenceNumber,
		fieldAcrobatName,
		paymentMode,
		country,
		currency,
	} = user;

	// const onInputChange = ({ target: { name, value } }) => {
	// 	const m = /^([0-9A-Za-z]+\s?)*$/;
	// 	const obj = {
	// 		...user,
	// 	};

	// 	setUser({ ...user, [name]: m.test(value) ? value : user[name] });
	// 	if (name == "operation") {
	// 		setOperationTypeList([]);
	// 	}
	// 	else {

	// 		obj[name] = value;
	// 	}
	// 	setUser(obj)
	// };

	const onInputChange = ({ target: { name, value } }) => {
		if (name === "paymentMode" || name === "currency") {
			setUser({ ...user, [name]: value });
			return;
		}
		const m = /^[0-9A-Za-z_ !@#$%^&*()\-+=,.?/]*$/;
		setUser({ ...user, [name]: m.test(value) ? value : user[name] });
		if (name == "operation") {
			setOperationTypeList([]);
		}
	};

	const getFeeMasterListRes = useSelector(
		({ adminGetFeeMasterList }) => adminGetFeeMasterList
	);

	const getFeeDefaultValuesRes = useSelector(
		({ adminGetFeeDefaultValues }) => adminGetFeeDefaultValues
	);

	const getRoleListRes = useSelector(({ getRoleList }) => getRoleList);

	const getFeeOperationTypeRes = useSelector(
		({ adminGetFeeOperationType }) => adminGetFeeOperationType
	);

	const addOrUpdateFeeRes = useSelector(
		({ adminAddOrUpdateFee }) => adminAddOrUpdateFee
	);

	const getKycActionTypeRes = useSelector(
		({ adminGetKycActionType }) => adminGetKycActionType
	);

	const getKycDocumentListRes = useSelector(
		({ adminGetKycDocumentList }) => adminGetKycDocumentList
	);

	const addOrUpdateKycDocumentRes = useSelector(
		({ adminAddOrUpdateKycDocument }) => adminAddOrUpdateKycDocument
	);

	const getCountryListRes = useSelector(({ getCountryList }) => getCountryList);
	console.log("getCountryListRes", getCountryListRes)

	const handleNoticationClose = () => {
		setNotificationOpen(false);
	};

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			getFeeMasterListReq();
		}
	}, [regenerateTokenRes.data.AuthToken]);

	const getFeeMasterListReq = () => {
		setIsLoading(true);
		setGetFeeMasterListStatus(true);
		let req = {
			feeName: searchFeeName,
			feeUnit: searchFeeUnit,
			// adminId: 2
			adminId: val.adminIDS

		};
		dispatch(adminGetFeeMasterList(req, regenerateTokenRes.data.AuthToken));
	};

	const getCountryListReq = () => {
		const req = {
			actionCustomerMasterRequestVO: {
				walletOwnerId: regenerateTokenRes.data.partnerId || "",
				country: "",
				countryCode: "",
				countryIso: ""
			}
		}
		dispatch(adminGetCountryList(req, authToken));


	};

	const adminCurrencyCodes = useSelector(({ adminCurrencyCode }) => adminCurrencyCode);
	console.log("adminCurrencyCodes", adminCurrencyCodes)

	useEffect(() => {
		const adminCurrReq = {
			loginDetails: {
				adminId: regenerateTokenRes.data.partnerId
			}
		}
		dispatch(adminCurrencyCode(adminCurrReq, authToken));
	}, [authToken]);




	useEffect(() => {
		if (regenerateTokenRes.data.status === "success" && regenerateTokenRes.data.AuthToken) {
			dispatch(getDefaultCurrencyList({
				loginDetails: {
					walletOwnerId: regenerateTokenRes.data.partnerId || "",
				}
			}, regenerateTokenRes.data.AuthToken)); // ✅ use direct value, not stale closure var
		}
	}, [regenerateTokenRes.data.AuthToken]); // ✅ re-run when token changes


	useEffect(() => {
		console.log("adminCurrencyList >>>", adminCurrencyList);
	}, [adminCurrencyList]);

	useEffect(() => {
		if (
			regenerateTokenRes.data.status === "success" &&
			regenerateTokenRes.data.AuthToken
		) {
			getCountryListReq();
		}
	}, [regenerateTokenRes.data.AuthToken]);


	useEffect(() => {
		if (getCountryListRes.data?.status == "success") {
			setCountryListArray(
				[].concat(getCountryListRes.data.customerMasterDetailsRequestVOList)
			);
		}
	}, [getCountryListRes.data?.status])


	const getFeeMasterListFunc = () => {
		if (getFeeMasterListStatus) {
			setIsLoading(false);
			if (getFeeMasterListRes.data.status == "success") {
				setGetFeeMasterListArray(
					[].concat(getFeeMasterListRes.data.feeMasterDetailsVOList)
				);
			}
			if (getFeeMasterListRes.data.status == "failed") {
				setGetFeeMasterListArray(getFeeMasterListRes.data);
				NotificationPopups(
					"error",
					"Failed",
					getFeeMasterListRes.data.description ||
					getFeeMasterListRes.description
				);
				if (
					getFeeMasterListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getFeeMasterListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getFeeMasterListRes.data.status == "NOT FOUND") {
				setGetFeeMasterListArray(getFeeMasterListRes.data);
				NotificationPopups(
					"error",
					"Failed",
					getFeeMasterListRes.data.description ||
					getFeeMasterListRes.description
				);
			}
		}
	};

	useEffect(() => {
		getFeeMasterListFunc();
	}, [getFeeMasterListRes.data.status]);

	const getFeeDefaultValuesReq = () => {
		let req = {
			// adminId: 2
			adminId: val.adminIDS
		};
		dispatch(adminGetFeeDefaultValues(req, authToken));
	};

	useEffect(() => {
		if (getFeeDefaultValuesRes.data.actionCustomerMasterResponseVO) {
			setUser({
				feeId: "",
				feeName: "",
				inputRequired: "",
				feeUnit: "",
				feeTechnicalName: "",
				transactionUnit: "",
				operation: "",
				operationType: "",
				frequency: "",
				level: "",
				feeOwner: "",
				paymentBy: "",
				status: "",
				sequenceNumber:
					getFeeDefaultValuesRes.data.actionCustomerMasterResponseVO
						.sequenceNumber,
				fieldAcrobatName: ""
			});
		}
	}, [getFeeDefaultValuesRes, addOpen]);

	const getRoleListReq = () => {
		setGetRoleStatus(true);
		let req = {
			ownerMasterRequestVO: {
				adminId: val.adminIDS
				// adminId: 2
			}
		};
		dispatch(getRoleList(req, authToken));
	};

	const getRoleListStatusFunc = () => {
		if (getRoleStatus) {
			if (getRoleListRes.data.status == "success") {
				setGetRoleResArray([].concat(getRoleListRes.data.roleList));
			}
			if (getRoleListRes.data.status == "failed") {
				setGetRoleResArray(getRoleListRes.data);
				if (
					getRoleListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getRoleListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		getRoleListStatusFunc();
	}, [getRoleListRes.data.status]);

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			getFeeDefaultValuesReq();
			getRoleListReq();
		}
	}, regenerateTokenRes.data.AuthToken);

	useEffect(() => {
		console.log(operationTypeList, "Operation Listttsss///////////");
	}, [operationTypeList]);

	useEffect(() => {
		console.log(operation, "///////////////////////////////////////");
	}, [operation]);

	const getFeeOperationTypeReq = () => {
		setFeeOperationTypeStatus(true);
		let req = {
			// adminId: 2,
			adminId: val.adminIDS,
			feeOperationName: operation
		};
		dispatch(adminGetFeeOperationType(req, authToken));
	};

	const getFeeOperationTypeFunc = () => {
		if (feeOperationTypeStatus) {
			if (getFeeOperationTypeRes.data.status == "success") {
				setFeeOperationTypeArray(
					[].concat(getFeeOperationTypeRes.data.currencyList)
				);
			}
			if (getFeeOperationTypeRes.data.status == "failed") {
				setFeeOperationTypeArray([].concat(getFeeOperationTypeRes.data));
				if (
					getFeeOperationTypeRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getFeeOperationTypeRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		getFeeOperationTypeFunc();
	}, [getFeeOperationTypeRes.data.status]);

	useEffect(() => {
		getFeeOperationTypeReq();
	}, [operation]);

	const addOrUpdateFeeReq = () => {
		setAddOrUpdateFeeStatus(true);
		let req = {
			feeID: feeId,
			// adminId: 2,
			adminId: val.adminIDS,
			feeName: feeName,
			inputRequired: inputRequired,
			feeTechName: feeTechnicalName,
			feeUnit: feeUnit,
			keyWord: operation,
			subKeyWord: transactionUnit,
			operationTypeList: operationTypeList,
			frequency: frequency,
			levelList: levelList,
			feeOwner: feeOwner,
			paymentBy: paymentBy,
			status: status,
			sequenceNumber: 17,
			acrobatName: fieldAcrobatName,
			paymentMode: operationTypeList.some(item => {
				const type = item.toLowerCase().replace("_", " ");
				return type === "card transfer" || type === "wallet" || type === "bank transfer"
			})
				? paymentMode
				: "",
			country: country,
			currency: currency,
		};
		dispatch(adminAddOrUpdateFee(req, authToken));
	};

	const addOrUpdateFeeFunc = () => {
		if (addOrUpdateFeeStatus) {
			if (addOrUpdateFeeRes.data.status == "success") {
				setAddOrUpdateFeeArray(addOrUpdateFeeRes.data);
				setEditOpen(false);
				setAddOpen(false);
				setNotificationOpen(true);
				getFeeMasterListReq();
			}
			if (addOrUpdateFeeRes.data.status == "failed") {
				setAddOrUpdateFeeArray(addOrUpdateFeeRes.data);
				setEditOpen(false);
				setAddOpen(false);
				setNotificationOpen(true);
				if (
					addOrUpdateFeeRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					addOrUpdateFeeRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		addOrUpdateFeeFunc();
	}, [addOrUpdateFeeRes.data.status]);

	const getKycDocumentListReq = () => {
		setGetKycDocumentListStatus(true);
		let req = {
			// adminId: 2,
			adminId: val.adminIDS,
			actionType: searchActionType,
			docName: searchDocumentName
		};
		dispatch(adminGetKycDocumentList(req, authToken));
	};

	const getKycDocumentListFunc = () => {
		if (getKycDocumentListStatus) {
			if (getKycDocumentListRes.data.status == "success") {
				setGetKycDocumentListArray(
					[].concat(getKycDocumentListRes.data.commonKycDetailsList)
				);
			}
			if (getKycDocumentListRes.data.status == "failed") {
				setGetKycDocumentListArray(getKycDocumentListRes.data);
				if (
					getKycDocumentListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getKycDocumentListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		getKycDocumentListFunc();
	}, [getKycDocumentListRes.data.status]);

	// const addOrUpdateKycDocumentReq = () => {
	// 	setAddOrUpdateKycDocumentStatus(true);
	// 	let req = {
	// 		actionType: actionType,
	// 		docName: docName,
	// 		description: description,
	// 		adminId: 2,
	// 		kycId: docId
	// 	};
	// 	dispatch(adminAddOrUpdateKycDocument(req, authToken));
	// };

	const addOrUpdateKycDocumentFunc = () => {
		if (addOrUpdateKycDocumentStatus) {
			if (addOrUpdateKycDocumentRes.data.status == "success") {
				setAddOrUpdateKycDocumentArray(addOrUpdateKycDocumentRes.data);
				setEditOpen(false);
				setAddOpen(false);
				setNotificationOpen(true);
				getKycDocumentListReq();
				setUser({
					feeId: "",
					feeName: "",
					inputRequired: "",
					feeUnit: "",
					feeTechnicalName: "",
					transactionUnit: "",
					operation: "",
					operationType: "",
					frequency: "",
					level: "",
					feeOwner: "",
					paymentBy: "",
					status: "",
					sequenceNumber: "",
					fieldAcrobatName: ""
				});
				setLevelList([]);
				setOperationTypeList([]);
			}
			if (addOrUpdateKycDocumentRes.data.status == "failed") {
				setAddOrUpdateKycDocumentArray(addOrUpdateKycDocumentRes.data);
				setEditOpen(false);
				setAddOpen(false);
				setNotificationOpen(true);
				setUser({
					feeId: "",
					feeName: "",
					inputRequired: "",
					feeUnit: "",
					feeTechnicalName: "",
					transactionUnit: "",
					operation: "",
					operationType: "",
					frequency: "",
					level: "",
					feeOwner: "",
					paymentBy: "",
					status: "",
					sequenceNumber: "",
					fieldAcrobatName: ""
				});
				setLevelList([]);
				setOperationTypeList([]);
				if (
					addOrUpdateKycDocumentRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					addOrUpdateKycDocumentRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		addOrUpdateKycDocumentFunc();
	}, [addOrUpdateKycDocumentRes.data.status]);

	const getGetKycActionTypeReq = () => {
		setGetGetKycActionTypeStatus(true);
		let req = {
			// adminId: 2
			adminId: val.adminIDS
		};
		dispatch(adminGetkycActionType(req, authToken));
	};

	// useEffect(() => {
	// 	getGetKycActionTypeReq();
	// }, []);

	const getGetKycActionTypeFunc = () => {
		if (getKycActionTypeStatus) {
			if (getKycActionTypeRes.data.status == "success") {
				setGetKycActionTypeArray(getKycActionTypeRes.data.currencyList);
			}
			if (getKycActionTypeRes.data.status == "failed") {
				setGetKycActionTypeArray(getKycActionTypeRes.data);
				if (
					getKycActionTypeRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getKycActionTypeRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		getGetKycActionTypeFunc();
	}, [getKycActionTypeRes.data.status]);

	const setData = (row, fs) => {
		if (fs == "view") {
			setViewOpen(true);
		}
		if (fs == "edit") {
			setEditOpen(true);
		}
		setUser({
			feeId: row.feeID,
			feeName: row.feeName,
			inputRequired: row.inputRequired,
			feeUnit: row.feeUnit,
			feeTechnicalName: row.feeTechName,
			transactionUnit: row.subKeyWord,
			operation: row.keyWord,
			frequency: row.frequency,
			feeOwner: row.feeOwner,
			paymentBy: row.paymentBy,
			status: row.category,
			sequenceNumber: row.sequenceNumber,
			fieldAcrobatName: row.fieldAcrobatName,
			paymentMode: row.paymentMode || "",
			country: row.country || "",
			currency: row.currency || "",
		});
		setLevelList([].concat(row.role.split(",")));
		setOperationTypeList([].concat(row.chargeType.split(",")));
	};

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const handleClose = () => {
		setEditOpen(false);
		setViewOpen(false);
		setAddOpen(false);
		setUser({
			feeId: "",
			feeName: "",
			inputRequired: "",
			feeUnit: "",
			feeTechnicalName: "",
			transactionUnit: "",
			operation: "",
			operationType: "",
			frequency: "",
			level: "",
			feeOwner: "",
			paymentBy: "",
			status: "",
			sequenceNumber: "",
			fieldAcrobatName: "",
			paymentMode: "",
			country: "",
			currency: "",
		});
		setLevelList([]);
		setOperationTypeList([]);
	};

	const addProofType = () => {
		setAddOpen(true);
	};

	// http://localhost:8081/partnerServices/AdminServices/getFeeMappingList
	// axios.get('https://mob.paymentz.com/partnerServices/AdminServices/getFeeMappingList')
	// .then((response) => {
	// 	console.log(response)
	// })

	return (
		<>
			<Layout>
				<Card>
					<Grid
						container
						style={{
							padding: "10px",
							marginTop: "1rem",
							marginLeft: "1rem",
							gap: "10px"
						}}
					>
						<Grid item xs={12} md={4} sm={3} lg={6}></Grid>
						<Grid item xs={12} md={3} sm={3} lg={3}>
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={() => addProofType()}

							>
								Add New Fee Master
							</CustomButton>

							{/* <Button
								variant="contained"
								style={{ backgroundColor: "#00b9f5", color: "white" }}
								size="small"
								onClick={() => addProofType()}
							>
								Add New Fee Master
							</Button> */}
						</Grid>
						<Grid item xs={12} md={3} sm={3} lg={2}>
							<NavLink to="/index/FeeMapping">
								{/* <Button
									variant="contained"
									style={{ backgroundColor: "#00b9f5", color: "white" }}
									size="small"
								>
									Mapping Fee
								</Button> */}
								<CustomButton
									style={{
										padding: "8px"
									}}


								>
									Mapping Fee
								</CustomButton>
							</NavLink>
						</Grid>
					</Grid>

					<Grid
						container
						spacing={2}
						style={{ padding: "25px", marginTop: "2rem" }}
					>
						<Grid item xs={12} sm={6} md={4} lg={3}>
							<TextField
								size="small"
								color="primary"
								type="text"
								label="Fee Name"
								fullWidth={true}
								name="searchFeeName"
								value={searchFeeName || ""}
								onChange={handleChange}
								style={{ marginTop: "8px" }}
							></TextField>
						</Grid>
						<Grid item xs={12} sm={6} md={4} lg={3}>
							<TextField
								select
								size="small"
								color="primary"
								type="text"
								label="Fee Unit"
								fullWidth={true}
								name="searchFeeUnit"
								defaultValue={"Select Fee Unit" || searchFeeUnit}
								onChange={handleChange}
							>
								<MenuItem value="Select Fee Unit" selected="Select Fee Unit">
									Select Fee Unit
								</MenuItem>
								<MenuItem value="FlatRate">FlatRate</MenuItem>
								<MenuItem value="Percentage">Percentage</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={6} md={4} lg={3}>
							{/* <Button
								style={{
									backgroundColor: "#00b9f5",
									color: "white",
									marginTop: "9px"
								}}
								endIcon={<AiOutlineSearch />}
								variant="contained"
								onClick={getFeeMasterListReq}
							>
								Search
							</Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={getFeeMasterListReq}

							>
								Search <SearchIcon />
							</CustomButton>
						</Grid>
					</Grid>
				</Card>

				{isLoading ? (
					<LoadingSpinner />
				) : getFeeMasterListArray.length == undefined ||
					getFeeMasterListArray.status == "NOT FOUND" ||
					!getFeeMasterListStatus ? (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography variant="body1" style={{ fontWeight: "700" }}
									className="themeText"

								>
									Report Table
								</Typography>
							</Grid>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Alert
									className="my-3 tableHeaderColor"
									variant="secondary"
								// style={{ backgroundColor: "#00b9f5", color: "white" }}
								>
									No Records Found!
								</Alert>
							</Grid>
						</Grid>
					</Card>
				) : (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography variant="body1" style={{ fontWeight: "700" }}
									className="themeText"

								>
									Report Table
								</Typography>
							</Grid>
							<TableContainer component={Paper} className="my-3">
								<Table
									className={classes.table}
									size="small"
									aria-label="a dense table"
								>
									<TableHead>
										<TableRow className="tableHeaderColor">

											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Fee ID
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Fee Name
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Fee Unit
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Transaction Unit
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Operation
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Operation Type
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Level
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Fee Owner
											</TableCell>
											<TableCell
												colSpan={2}
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Action
											</TableCell>
										</TableRow>
									</TableHead>

									<TableBody>
										{getFeeMasterListArray &&
											[]
												.concat(getFeeMasterListArray)
												.slice(
													page * rowsPerPage,
													page * rowsPerPage + rowsPerPage
												)
												.map((row, index) => (
													<TableRow>
														<TableCell align="center">{row.feeID}</TableCell>
														<TableCell align="center">{row.feeName}</TableCell>
														<TableCell align="center">{row.feeUnit}</TableCell>
														<TableCell align="center">
															{row.subKeyWord}
														</TableCell>
														<TableCell align="center">{row.keyWord}</TableCell>
														<TableCell align="center">
															{row.chargeType}
														</TableCell>
														<TableCell align="center">{row.role}</TableCell>
														<TableCell align="center">{row.feeOwner}</TableCell>
														<TableCell align="center">
															<CustomButton
																style={{
																	padding: "8px"
																}}
																onClick={() => setData(row, view)}
															>
																<VisibilityIcon style={{ color: "#fff" }} />
															</CustomButton>
														</TableCell>
														<TableCell align="center">
															<CustomButton
																style={{
																	padding: "8px"
																}}
																onClick={() => setData(row, edit)}
															>
																<EditIcon style={{ color: "#fff" }} />
															</CustomButton>
														</TableCell>
													</TableRow>
												))}
									</TableBody>
								</Table>
								<TablePagination
									rowsPerPageOptions={[5, 10, 25]}
									component="div"
									count={getFeeMasterListArray.length}
									rowsPerPage={rowsPerPage}
									page={page}
									onPageChange={handleChangePage}
									onRowsPerPageChange={handleChangeRowsPerPage}
								/>
							</TableContainer>
						</Grid>
					</Card>
				)}
				<div>
					<Dialog open={viewOpen} onClose={handleClose}>
						<DialogTitle>View Fee Master</DialogTitle>
						<DialogContent>
							<TextField
								required
								disabled
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								label="Fee Name"
								fullWidth={true}
								name="feeName"
								variant="standard"
								value={feeName || ""}
							></TextField>
							<TextField
								required
								disabled
								select
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								variant="standard"
								label="Input Required"
								fullWidth={true}
								name="inputRequired"


								value={inputRequired || ""}
							>
								<MenuItem value="N">No</MenuItem>
								<MenuItem value="Y">Yes</MenuItem>
							</TextField>
							<TextField
								required
								disabled
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								label="Fee Technical Name"
								fullWidth={true}
								name="feeTechnicalName"
								variant="standard"

								value={feeTechnicalName || ""}
							></TextField>
							<TextField
								required
								disabled
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								label="Fee Unit"
								fullWidth={true}
								name="feeUnit"
								variant="standard"

								value={feeUnit || ""}
							></TextField>
							<TextField
								required
								disabled
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								label="Transaction Unit"
								fullWidth={true}
								name="transactionUnit"
								variant="standard"

								value={transactionUnit || ""}
							></TextField>
							<TextField
								required
								disabled
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								label="Operation"
								fullWidth={true}
								name="operation"
								variant="standard"

								value={operation || ""}
							></TextField>
							{/* Payment Mode - shown only when Card Transfer is selected */}
							{operationTypeList.some(item => item.toLowerCase().replace("_", " ") === "card transfer") && (
								<TextField
									disabled
									required
									disabled
									select
									onChange={(e) => onInputChange(e)}
									style={{ marginTop: "10px" }}
									size="small"
									color="primary"
									variant="standard"
									label="Payment Mode"
									fullWidth={true}
									name="paymentMode"
									value={paymentMode || ""}
								>
									<MenuItem value="">Select Payment Mode</MenuItem>
									<MenuItem value="Credit">Credit</MenuItem>
									<MenuItem value="Debit">Debit</MenuItem>
								</TextField>
							)}
							{/* {operationTypeList.some(
								item => item.toLowerCase().replace("_", " ") === "wallet" || "bank transfer"
							) && (
									<TextField
										disabled
										required
										select
										onChange={(e) => onInputChange(e)}
										style={{ marginTop: "10px" }}
										size="small"
										color="primary"
										variant="standard"
										label="Alternate payment Mode"
										fullWidth={true}
										name="paymentMode"
										value={paymentMode || ""}
									>
										<MenuItem value="">Select Alternate payment Mode</MenuItem>
										<MenuItem value="BANCONTACT">BANCONTACT</MenuItem>
										<MenuItem value="WECHATPAY">WECHATPAY</MenuItem>
										<MenuItem value="UPI">UPI</MenuItem>
										<MenuItem value="SWISH">SWISH</MenuItem>
										<MenuItem value="SEPADIRECTDEBIT">SEPA DIRECT DEBIT</MenuItem>
										<MenuItem value="ALIPAY">ALIPAY</MenuItem>
										<MenuItem value="IDEAL">IDEAL</MenuItem>
										{/* Only for Bank Transfer */}
							{/* {operationTypeList.some(
											item =>
												item.toLowerCase().replace("_", " ") === "bank transfer"
										) && (
												<>
													<MenuItem value="OPENBANKING">OPENBANKING</MenuItem>
													<MenuItem value="OPENBANKINGUK">OPENBANKINGUK</MenuItem>
												</>
											)}
									</TextField>
								)}  */}

							{/* Define helper booleans first — put these just above the JSX return or inline */}
							{(() => {
								const hasWallet = operationTypeList.some(
									item => item.toLowerCase().replace(/_/g, " ") === "wallet"
								);
								const hasBankTransfer = operationTypeList.some(
									item => item.toLowerCase().replace(/_/g, " ") === "bank transfer"
								);

								return (hasWallet || hasBankTransfer) ? (
									<TextField
										required
										disabled
										select
										onChange={(e) => onInputChange(e)}
										style={{ marginTop: "10px" }}
										size="small"
										color="primary"
										variant="standard"
										label="Alternate payment Mode"
										fullWidth={true}
										name="paymentMode"
										value={paymentMode || ""}
									>
										<MenuItem value="">Select Alternate payment Mode</MenuItem>

										{/* Wallet-only options */}
										{hasWallet && [
											<MenuItem key="BANCONTACT" value="BANCONTACT">BANCONTACT</MenuItem>,
											<MenuItem key="WECHATPAY" value="WECHATPAY">WECHATPAY</MenuItem>,
											<MenuItem key="UPI" value="UPI">UPI</MenuItem>,
											<MenuItem key="SWISH" value="SWISH">SWISH</MenuItem>,
											<MenuItem key="SEPA DIRECT DEBIT" value="SEPA DIRECT DEBIT">SEPA DIRECT DEBIT</MenuItem>,
											<MenuItem key="ALIPAY" value="ALIPAY">ALIPAY</MenuItem>,
											<MenuItem key="IDEAL" value="IDEAL">IDEAL</MenuItem>,
										]}

										{/* Bank Transfer-only options */}
										{hasBankTransfer && [
											<MenuItem key="OPENBANKING" value="OPENBANKING">OPENBANKING</MenuItem>,
											<MenuItem key="OPENBANKINGUK" value="OPENBANKINGUK">OPENBANKINGUK</MenuItem>,
										]}
									</TextField>
								) : null;
							})()}

							<TextField
								required
								disabled
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								label="Operation Type"
								fullWidth={true}
								name="operationType"
								variant="standard"

								value={operationTypeList || ""}
							></TextField>
							<TextField
								required
								disabled
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								label="Frequency"
								fullWidth={true}
								name="frequency"
								variant="standard"

								value={frequency || ""}
							></TextField>
							<TextField
								required
								disabled
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								label="Level"
								fullWidth={true}
								name="level"
								variant="standard"

								value={levelList || ""}
							></TextField>
							<TextField
								required
								disabled
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								label="Fee Owner"
								fullWidth={true}
								name="feeOwner"
								variant="standard"

								value={feeOwner || ""}
							></TextField>
							<TextField
								required
								disabled
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								label="PaymentBy"
								fullWidth={true}
								name="paymentBy"
								variant="standard"

								value={paymentBy || ""}
							></TextField>
							<TextField
								disabled
								style={{ marginTop: "10px" }}
								size="small"
								label="Country"
								fullWidth={true}
								name="country"
								variant="standard"
								value={
									(() => {
										const found = countryListArray.find((c) => c.countryIso === country);
										return found ? `${found.countryIso} - ${found.countryName}` : country || "";
									})()
								}
							/>
							<TextField
								disabled
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								label="Currency"
								fullWidth={true}
								name="currency"
								variant="standard"
								value={currency || ""}
							/>
							<TextField
								required
								disabled
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								label="Status"
								fullWidth={true}
								name="status"
								variant="standard"

								value={status || ""}
							></TextField>
							<TextField
								required
								disabled
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								label="Sequence Number"
								fullWidth={true}
								name="sequenceNumber"
								variant="standard"

								value={sequenceNumber || ""}
							></TextField>
							<TextField
								disabled
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								label="Field Acrobat Name"
								fullWidth={true}
								name="fieldAcrobatName"
								variant="standard"

								value={fieldAcrobatName || ""}
							></TextField>
						</DialogContent>
						<DialogActions style={{ padding: "14px" }}>
							<Button
								style={{
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleClose}
							>
								Close
							</Button>
						</DialogActions>
					</Dialog>
				</div>
				<div>
					<Dialog open={editOpen} onClose={handleClose}>
						<DialogTitle>Edit Fee Master</DialogTitle>
						<DialogContent>

							<TextField
								required
								onChange={(e) => onInputChange(e)}
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								label="Fee Name"
								fullWidth={true}
								name="feeName"
								value={feeName || ""}
							></TextField>
							<TextField
								required
								select
								onChange={(e) => onInputChange(e)}
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								label="Input Required"
								fullWidth={true}
								name="inputRequired"
								defaultValue={inputRequired || "Select Input Required"}
							>
								<MenuItem
									value="Select Input Required"
									selected="Select Input Required"
								>
									Select Input Required
								</MenuItem>
								<MenuItem value="N">No</MenuItem>
								<MenuItem value="Y">Yes</MenuItem>
							</TextField>
							<TextField
								required
								onChange={(e) => onInputChange(e)}
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								label="Fee Technical Name"
								fullWidth={true}
								name="feeTechnicalName"
								value={feeTechnicalName || ""}
							></TextField>
							<TextField
								required
								select
								onChange={(e) => onInputChange(e)}
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								label="Fee Unit"
								fullWidth={true}
								name="feeUnit"
								defaultValue={feeUnit || "Select Fee Unit"}
							>
								<MenuItem value="Select Fee Unit" selected="Select Fee Unit">
									Select Fee Unit
								</MenuItem>
								{getFeeDefaultValuesRes.data.actionCustomerMasterResponseVO &&
									getFeeDefaultValuesRes.data.actionCustomerMasterResponseVO.feeUnitList.map(
										(x) => <MenuItem value={x}>{x}</MenuItem>
									)}
							</TextField>
							<TextField
								required
								select
								onChange={(e) => onInputChange(e)}
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								label="Transaction Unit"
								fullWidth={true}
								name="transactionUnit"
								defaultValue={transactionUnit || "Select Transaction Unit"}
							>
								<MenuItem
									value="Select Transaction Unit"
									selected="Select Transaction Unit"
								>
									Select Transaction Unit
								</MenuItem>
								{getFeeDefaultValuesRes.data.actionCustomerMasterResponseVO &&
									getFeeDefaultValuesRes.data.actionCustomerMasterResponseVO.transactionUnitList.map(
										(x) => <MenuItem value={x}>{x}</MenuItem>
									)}
							</TextField>
							<TextField
								required
								select
								onChange={(e) => onInputChange(e)}
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								label="Operation"
								fullWidth={true}
								name="operation"
								defaultValue={operation || "Select Operation"}
							>
								<MenuItem value="Select Operation" selected="Select Operation">
									Select Operation
								</MenuItem>
								{getFeeDefaultValuesRes.data.actionCustomerMasterResponseVO &&
									getFeeDefaultValuesRes.data.actionCustomerMasterResponseVO.feeOperationList.map(
										(x) => <MenuItem value={x}>{x}</MenuItem>
									)}
							</TextField>
							{getFeeOperationTypeRes.data.currencyList && (
								<FormControl
									style={{
										width: "100%",
										margin: "0",
										maxWidth: "unset",
										minWidth: "unset",
										marginTop: "10px"
									}}
									className={classes.formControl}
								>
									<InputLabel style={{ color: "#092058" }}>
										Operation Type*
									</InputLabel>
									<Select
										multiple
										color="primary"
										value={operationTypeList}
										onChange={handleChange}
										name="operationType"
										input={<Input />}
										renderValue={(selected) => selected.join(",")}
										MenuProps={MenuProps}
									>
										{getFeeOperationTypeRes.data.currencyList &&
											feeOperationTypeArray.map((name) => (
												<MenuItem key={name} value={name}>
													<Checkbox
														color="primary"
														checked={operationTypeList.indexOf(name) > -1}
													/>
													<ListItemText primary={name} />
												</MenuItem>
											))}
									</Select>
								</FormControl>
							)}

							{/* Payment Mode - shown only when Card Transfer is selected */}
							{operationTypeList.some(item => item.toLowerCase().replace("_", " ") === "card transfer") && (
								<TextField
									required
									select
									onChange={(e) => onInputChange(e)}
									style={{ marginTop: "10px" }}
									size="small"
									color="primary"
									variant="standard"
									label="Payment Mode"
									fullWidth={true}
									name="paymentMode"
									value={paymentMode || ""}
								>
									<MenuItem value="">Select Payment Mode</MenuItem>
									<MenuItem value="Credit">Credit</MenuItem>
									<MenuItem value="Debit">Debit</MenuItem>
								</TextField>
							)}

							{/* Payment Mode - shown only when Card Transfer is selected */}
							{/* {operationTypeList.some(
								item => item.toLowerCase().replace("_", " ") === "wallet" || "Bank Transfer"
							) && (
									<TextField
										required
										select
										onChange={(e) => onInputChange(e)}
										style={{ marginTop: "10px" }}
										size="small"
										color="primary"
										variant="standard"
										label="Alternate payment Mode"
										fullWidth={true}
										name="paymentMode"
										value={paymentMode || ""}
									>
										<MenuItem value="">Select Alternate payment Mode</MenuItem>
										<MenuItem value="BANCONTACT">BANCONTACT</MenuItem>
										<MenuItem value="WECHATPAY">WECHATPAY</MenuItem>
										<MenuItem value="UPI">UPI</MenuItem>
										<MenuItem value="SWISH">SWISH</MenuItem>
										<MenuItem value="SEPADIRECTDEBIT">SEPA DIRECT DEBIT</MenuItem>
										<MenuItem value="ALIPAY">ALIPAY</MenuItem>
										<MenuItem value="IDEAL">IDEAL</MenuItem>
										{/* Only for Bank Transfer */}
							{/* {operationTypeList.some(
											item =>
												item.toLowerCase().replace("_", " ") === "bank transfer"
										) && (
												<>
													<MenuItem value="OPENBANKING">OPENBANKING</MenuItem>
													<MenuItem value="OPENBANKINGUK">OPENBANKINGUK</MenuItem>
												</>
											)}

									</TextField>
								)}  */}

							{/* Define helper booleans first — put these just above the JSX return or inline */}
							{(() => {
								const hasWallet = operationTypeList.some(
									item => item.toLowerCase().replace(/_/g, " ") === "wallet"
								);
								const hasBankTransfer = operationTypeList.some(
									item => item.toLowerCase().replace(/_/g, " ") === "bank transfer"
								);

								return (hasWallet || hasBankTransfer) ? (
									<TextField
										required
										select
										onChange={(e) => onInputChange(e)}
										style={{ marginTop: "10px" }}
										size="small"
										color="primary"
										variant="standard"
										label="Alternate payment Mode"
										fullWidth={true}
										name="paymentMode"
										value={paymentMode || ""}
									>
										<MenuItem value="">Select Alternate payment Mode</MenuItem>

										{/* Wallet-only options */}
										{hasWallet && [
											<MenuItem key="BANCONTACT" value="BANCONTACT">BANCONTACT</MenuItem>,
											<MenuItem key="WECHATPAY" value="WECHATPAY">WECHATPAY</MenuItem>,
											<MenuItem key="UPI" value="UPI">UPI</MenuItem>,
											<MenuItem key="SWISH" value="SWISH">SWISH</MenuItem>,
											<MenuItem key="SEPA DIRECT DEBIT" value="SEPA DIRECT DEBIT">SEPA DIRECT DEBIT</MenuItem>,
											<MenuItem key="ALIPAY" value="ALIPAY">ALIPAY</MenuItem>,
											<MenuItem key="IDEAL" value="IDEAL">IDEAL</MenuItem>,
										]}

										{/* Bank Transfer-only options */}
										{hasBankTransfer && [
											<MenuItem key="OPENBANKING" value="OPENBANKING">OPENBANKING</MenuItem>,
											<MenuItem key="OPENBANKINGUK" value="OPENBANKINGUK">OPENBANKINGUK</MenuItem>,
										]}
									</TextField>
								) : null;
							})()}
							{/* <TextField
								required
								select
								onChange={(e) => onInputChange(e)}
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								label="Operation Type"
								fullWidth={true}
								name="operationType"
								defaultValue={operationType || "Select Operation Type"}
							>
								<MenuItem
									value="Select Operation Type"
									selected="Select Operation Type"
								>
									Select Operation Type
								</MenuItem>
								{feeOperationTypeArray &&
									feeOperationTypeArray.map((x) => (
										<MenuItem value={x}>{x}</MenuItem>
									))}
							</TextField> */}
							<TextField
								required
								select
								onChange={(e) => onInputChange(e)}
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								label="Frequency"
								fullWidth={true}
								name="frequency"
								defaultValue={frequency || "Select Frequency"}
							>
								<MenuItem value="Select Frequency" selected="Select Frequency">
									Select Frequency
								</MenuItem>
								{getFeeDefaultValuesRes.data.actionCustomerMasterResponseVO &&
									getFeeDefaultValuesRes.data.actionCustomerMasterResponseVO.frequencyList.map(
										(x) => <MenuItem value={x}>{x}</MenuItem>
									)}
							</TextField>
							{getRoleListRes.data.roleList && (
								<FormControl
									style={{
										width: "100%",
										margin: "0",
										maxWidth: "unset",
										minWidth: "unset",
										marginTop: "10px"
									}}
									className={classes.formControl}
								>
									<InputLabel style={{ color: "#092058" }}>Level*</InputLabel>
									<Select
										multiple
										color="primary"
										value={levelList}
										onChange={handleChange}
										name="level"
										input={<Input />}
										renderValue={(selected) => selected.join(",")}
										MenuProps={MenuProps}
									>
										{getRoleListRes.data.roleList &&
											getRoleResArray.map((name) => (
												<MenuItem key={name.role} value={name.role}>
													<Checkbox
														color="primary"
														checked={levelList.indexOf(name.role) > -1}
													/>
													<ListItemText primary={name.role} />
												</MenuItem>
											))}
									</Select>
								</FormControl>
							)}
							{/* <TextField
								required
								select
								onChange={(e) => onInputChange(e)}
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								label="Level"
								fullWidth={true}
								name="level"
								defaultValue={level || "Select Level"}
							>
								<MenuItem value="Select Level" selected="Select Level">
									Select Level
								</MenuItem>
								{getRoleListRes.data.roleList &&
									getRoleResArray.map((x) => (
										<MenuItem value={x.role}>{x.role}</MenuItem>
									))}
							</TextField> */}
							<TextField
								required
								select
								onChange={(e) => onInputChange(e)}
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								label="Fee Owner"
								fullWidth={true}
								name="feeOwner"
								defaultValue={feeOwner || "Select Fee Owner"}
							>
								<MenuItem value="Select Fee Owner" selected="Select Fee Owner">
									Select Fee Owner
								</MenuItem>
								{getRoleListRes.data.roleList &&
									getRoleResArray.map((x) => (
										<MenuItem value={x.role}>{x.role}</MenuItem>
									))}
							</TextField>
							<TextField
								required
								select
								onChange={(e) => onInputChange(e)}
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								label="PaymentBy"
								fullWidth={true}
								name="paymentBy"
								defaultValue={paymentBy || "Select PaymentBy"}
							>
								<MenuItem value="Select PaymentBy" selected="Select PaymentBy">
									Select PaymentBy
								</MenuItem>
								{getFeeDefaultValuesRes.data.actionCustomerMasterResponseVO &&
									getFeeDefaultValuesRes.data.actionCustomerMasterResponseVO.paymentByList.map(
										(x) => <MenuItem value={x}>{x}</MenuItem>
									)}
							</TextField>
							<TextField
								required
								select
								onChange={(e) => onInputChange(e)}
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								label="Status"
								fullWidth={true}
								name="status"
								defaultValue={status || "Select Status"}
							>
								<MenuItem value="Select Status" selected="Select Status">
									Select Status
								</MenuItem>
								{getFeeDefaultValuesRes.data.actionCustomerMasterResponseVO &&
									getFeeDefaultValuesRes.data.actionCustomerMasterResponseVO.feeStatus.map(
										(x) => <MenuItem value={x}>{x}</MenuItem>
									)}
							</TextField>
							<TextField
								required
								select
								onChange={(e) => onInputChange(e)}
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								variant="standard"
								label="Country"
								fullWidth={true}
								name="country"
								value={country || ""}
							>
								<MenuItem value="">Select Country</MenuItem>
								{countryListArray.map((c) => (
									<MenuItem key={c.id} value={c.countryIso}>
										{c.countryName}
									</MenuItem>
								))}
							</TextField>
							<TextField
								select
								size="small"
								color="primary"
								label="Currency"
								fullWidth={true}
								variant="standard"
								name="currency"                          // ✅ was "searchCurrency"
								value={currency || ""}                   // ✅ was searchCurrency
								onChange={(e) => onInputChange(e)}       // ✅ was handleChange
							>
								<MenuItem value="">Select Currency</MenuItem>
								{adminCurrencyCodes.success &&
									[].concat(adminCurrencyCodes.data.currencyList)
										.map((x) => {
											const code = x.replace(/^\d+-/, ""); // strips "1-", "13-", etc.
											return <MenuItem key={x} value={code}>{code}</MenuItem>;
										})}
							</TextField>
							<TextField
								required
								disabled
								onChange={(e) => onInputChange(e)}
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								label="Sequence Number"
								fullWidth={true}
								name="sequenceNumber"
								value={sequenceNumber || ""}
							></TextField>
							<TextField
								onChange={(e) => onInputChange(e)}
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								label="Field Acrobat Name"
								fullWidth={true}
								name="fieldAcrobatName"
								value={fieldAcrobatName || ""}
							></TextField>
						</DialogContent>
						<DialogActions style={{ padding: "14px" }}>
							<Button
								style={{
									backgroundColor: "#fff",
									color: "#000"
								}}
								variant="contained"
								onClick={handleClose}
							>
								Cancel
							</Button>
							<Button
								style={{
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={addOrUpdateFeeReq}
							>
								Save
							</Button>
						</DialogActions>
					</Dialog>
				</div>

				<div>
					<Dialog open={addOpen} onClose={handleClose}>
						<DialogTitle style={{ minWidth: "600px" }}>
							Add Fee Master
						</DialogTitle>
						<DialogContent>
							<TextField
								required
								onChange={(e) => onInputChange(e)}
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								variant="standard"
								label="Fee Name"
								fullWidth={true}
								name="feeName"
								value={feeName || ""}
							></TextField>
							<TextField
								required
								select
								onChange={(e) => onInputChange(e)}
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								variant="standard"

								label="Input Required"
								fullWidth={true}
								name="inputRequired"
								defaultValue={"Select Input Required" || inputRequired}
							>
								<MenuItem
									value="Select Input Required"
									selected="Select Input Required"
								>
									Select Input Required
								</MenuItem>
								<MenuItem value="N">No</MenuItem>
								<MenuItem value="Y">Yes</MenuItem>
							</TextField>
							<TextField
								required
								onChange={(e) => onInputChange(e)}
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								variant="standard"

								type="text"
								label="Fee Technical Name"
								fullWidth={true}
								name="feeTechnicalName"
								value={feeTechnicalName || ""}
							></TextField>
							<TextField
								required
								select
								onChange={(e) => onInputChange(e)}
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								variant="standard"

								type="text"
								label="Fee Unit"
								fullWidth={true}
								name="feeUnit"
								defaultValue={"Select Fee Unit" || feeUnit}
							>
								<MenuItem value="Select Fee Unit" selected="Select Fee Unit">
									Select Fee Unit
								</MenuItem>
								{getFeeDefaultValuesRes.data.actionCustomerMasterResponseVO &&
									getFeeDefaultValuesRes.data.actionCustomerMasterResponseVO.feeUnitList.map(
										(x) => <MenuItem value={x}>{x}</MenuItem>
									)}
							</TextField>
							<TextField
								required
								select
								onChange={(e) => onInputChange(e)}
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								variant="standard"

								type="text"
								label="Transaction Unit"
								fullWidth={true}
								name="transactionUnit"
								defaultValue={"Select Transaction Unit" || transactionUnit}
							>
								<MenuItem
									value="Select Transaction Unit"
									selected="Select Transaction Unit"
								>
									Select Transaction Unit
								</MenuItem>
								{getFeeDefaultValuesRes.data.actionCustomerMasterResponseVO &&
									getFeeDefaultValuesRes.data.actionCustomerMasterResponseVO.transactionUnitList.map(
										(x) => <MenuItem value={x}>{x}</MenuItem>
									)}
							</TextField>
							<TextField
								required
								select
								onChange={(e) => onInputChange(e)}
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								variant="standard"

								type="text"
								label="Operation"
								fullWidth={true}
								name="operation"
								defaultValue={"Select Operation" || operation}
							>
								<MenuItem value="Select Operation" selected="Select Operation">
									Select Operation
								</MenuItem>
								{getFeeDefaultValuesRes.data.actionCustomerMasterResponseVO &&
									getFeeDefaultValuesRes.data.actionCustomerMasterResponseVO.feeOperationList.map(
										(x) => <MenuItem value={x}>{x}</MenuItem>
									)}
							</TextField>
							<FormControl
								style={{
									width: "100%",
									margin: "0",
									maxWidth: "unset",
									minWidth: "unset",
									marginTop: "10px"
								}}
								className={classes.formControl}
							>
								<InputLabel style={{ color: "#092058" }}>
									Operation Type*
								</InputLabel>
								<Select
									multiple
									color="primary"
									value={operationTypeList}
									onChange={handleChange}
									name="operationType"
									input={<Input />}
									renderValue={(selected) => selected.join(",")}
									MenuProps={MenuProps}
								>
									{getFeeOperationTypeRes.data.currencyList &&
										feeOperationTypeArray.map((name) => (
											<MenuItem key={name} value={name}>
												<Checkbox
													color="primary"
													checked={operationTypeList.indexOf(name) > -1}
												/>
												<ListItemText primary={name} />
											</MenuItem>
										))}
								</Select>
							</FormControl>

							{/* Payment Mode - shown only when Card Transfer is selected */}
							{operationTypeList.some(item =>
								item.toLowerCase().replace("_", " ") === "card transfer"
							) && (
									<TextField
										required
										select
										onChange={(e) => onInputChange(e)}
										style={{ marginTop: "10px" }}
										size="small"
										color="primary"
										variant="standard"
										label="Payment Mode"
										fullWidth={true}
										name="paymentMode"
										value={paymentMode || ""}
									>
										<MenuItem value="">Select Payment Mode</MenuItem>
										<MenuItem value="Credit">Credit</MenuItem>
										<MenuItem value="Debit">Debit</MenuItem>
									</TextField>
								)}

							{/* {operationTypeList.some(
								item => item.toLowerCase().replace("_", " ") === "wallet" || "bank transfer"
							) && (
									<TextField
										required
										select
										onChange={(e) => onInputChange(e)}
										style={{ marginTop: "10px" }}
										size="small"
										color="primary"
										variant="standard"
										label="Alternate payment Mode"
										fullWidth={true}
										name="paymentMode"
										value={paymentMode || ""}
									>
										<MenuItem value="">Select Alternate payment Mode</MenuItem>
										<MenuItem value="BANCONTACT">BANCONTACT</MenuItem>
										<MenuItem value="WECHATPAY">WECHATPAY</MenuItem>
										<MenuItem value="UPI">UPI</MenuItem>
										<MenuItem value="SWISH">SWISH</MenuItem>
										<MenuItem value="SEPADIRECTDEBIT">SEPA DIRECT DEBIT</MenuItem>
										<MenuItem value="ALIPAY">ALIPAY</MenuItem>
										<MenuItem value="IDEAL">IDEAL</MenuItem>
										{operationTypeList.some(
											item =>
												item.toLowerCase().replace("_", " ") === "bank transfer"
										) && (
												<>
													<MenuItem value="OPENBANKING">OPENBANKING</MenuItem>
													<MenuItem value="OPENBANKINGUK">OPENBANKINGUK</MenuItem>
												</>
											)}
									</TextField>
								)} */}

							{/* Define helper booleans first — put these just above the JSX return or inline */}
							{(() => {
								const hasWallet = operationTypeList.some(
									item => item.toLowerCase().replace(/_/g, " ") === "wallet"
								);
								const hasBankTransfer = operationTypeList.some(
									item => item.toLowerCase().replace(/_/g, " ") === "bank transfer"
								);

								return (hasWallet || hasBankTransfer) ? (
									<TextField
										required
										select
										onChange={(e) => onInputChange(e)}
										style={{ marginTop: "10px" }}
										size="small"
										color="primary"
										variant="standard"
										label="Alternate payment Mode"
										fullWidth={true}
										name="paymentMode"
										value={paymentMode || ""}
									>
										<MenuItem value="">Select Alternate payment Mode</MenuItem>

										{/* Wallet-only options */}
										{hasWallet && [
											<MenuItem key="BANCONTACT" value="BANCONTACT">BANCONTACT</MenuItem>,
											<MenuItem key="WECHATPAY" value="WECHATPAY">WECHATPAY</MenuItem>,
											<MenuItem key="UPI" value="UPI">UPI</MenuItem>,
											<MenuItem key="SWISH" value="SWISH">SWISH</MenuItem>,
											<MenuItem key="SEPA DIRECT DEBIT" value="SEPA DIRECT DEBIT">SEPA DIRECT DEBIT</MenuItem>,
											<MenuItem key="ALIPAY" value="ALIPAY">ALIPAY</MenuItem>,
											<MenuItem key="IDEAL" value="IDEAL">IDEAL</MenuItem>,
										]}

										{/* Bank Transfer-only options */}
										{hasBankTransfer && [
											<MenuItem key="OPENBANKING" value="OPENBANKING">OPENBANKING</MenuItem>,
											<MenuItem key="OPENBANKINGUK" value="OPENBANKINGUK">OPENBANKINGUK</MenuItem>,
										]}
									</TextField>
								) : null;
							})()}

							<TextField
								required
								select
								onChange={(e) => onInputChange(e)}
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								variant="standard"

								type="text"
								label="Frequency"
								fullWidth={true}
								name="frequency"
								defaultValue={"Select Frequency" || frequency}
							>
								<MenuItem value="Select Frequency" selected="Select Frequency">
									Select Frequency
								</MenuItem>
								{getFeeDefaultValuesRes.data.actionCustomerMasterResponseVO &&
									getFeeDefaultValuesRes.data.actionCustomerMasterResponseVO.frequencyList.map(
										(x) => <MenuItem value={x}>{x}</MenuItem>
									)}
							</TextField>
							<FormControl
								style={{
									width: "100%",
									margin: "0",
									maxWidth: "unset",
									minWidth: "unset",
									marginTop: "10px"
								}}
								className={classes.formControl}
							>
								<InputLabel style={{ color: "#092058" }}>Level*</InputLabel>
								<Select
									multiple
									color="primary"
									value={levelList}
									onChange={handleChange}
									name="level"
									input={<Input />}
									renderValue={(selected) => selected.join(",")}
									MenuProps={MenuProps}
								>
									{getRoleListRes.data.roleList &&
										getRoleResArray.map((name) => (
											<MenuItem key={name.role} value={name.role}>
												<Checkbox
													color="primary"
													checked={levelList.indexOf(name.role) > -1}
												/>
												<ListItemText primary={name.role} />
											</MenuItem>
										))}
								</Select>
							</FormControl>
							<TextField
								required
								select
								onChange={(e) => onInputChange(e)}
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								variant="standard"

								type="text"
								label="Fee Owner"
								fullWidth={true}
								name="feeOwner"
								defaultValue={"Select Fee Owner" || feeOwner}
							>
								<MenuItem value="Select Fee Owner" selected="Select Fee Owner">
									Select Fee Owner
								</MenuItem>
								{getRoleListRes.data.roleList &&
									getRoleResArray.map((x) => (
										<MenuItem value={x.role}>{x.role}</MenuItem>
									))}
							</TextField>
							<TextField
								required
								select
								onChange={(e) => onInputChange(e)}
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								label="PaymentBy"
								variant="standard"

								fullWidth={true}
								name="paymentBy"
								defaultValue={"Select PaymentBy" || paymentBy}
							>
								<MenuItem value="Select PaymentBy" selected="Select PaymentBy">
									Select PaymentBy
								</MenuItem>
								{getFeeDefaultValuesRes.data.actionCustomerMasterResponseVO &&
									getFeeDefaultValuesRes.data.actionCustomerMasterResponseVO.paymentByList.map(
										(x) => <MenuItem value={x}>{x}</MenuItem>
									)}
							</TextField>
							<TextField
								required
								select
								onChange={(e) => onInputChange(e)}
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								label="Status"
								variant="standard"

								fullWidth={true}
								name="status"
								defaultValue={"Select Status" || status}
							>
								<MenuItem value="Select Status" selected="Select Status">
									Select Status
								</MenuItem>
								{getFeeDefaultValuesRes.data.actionCustomerMasterResponseVO &&
									getFeeDefaultValuesRes.data.actionCustomerMasterResponseVO.feeStatus.map(
										(x) => <MenuItem value={x}>{x}</MenuItem>
									)}
							</TextField>
							<TextField
								required
								select
								onChange={(e) => onInputChange(e)}
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								variant="standard"
								label="Country"
								fullWidth={true}
								name="country"
								value={country || ""}
							>
								<MenuItem value="">Select Country</MenuItem>
								{countryListArray.map((c) => (
									<MenuItem key={c.id} value={c.countryIso}>
										{c.countryName}
									</MenuItem>
								))}
							</TextField>

							<TextField
								select
								size="small"
								color="primary"
								label="Currency"
								fullWidth={true}
								variant="standard"
								name="currency"
								value={currency || ""}
								onChange={(e) => onInputChange(e)}
							>
								<MenuItem value="">Select Currency</MenuItem>
								{adminCurrencyCodes.success &&
									[].concat(adminCurrencyCodes.data.currencyList)
										.map((x) => {
											const code = x.replace(/^\d+-/, ""); // strips "1-", "13-", etc.
											return <MenuItem key={x} value={code}>{code}</MenuItem>;
										})}
							</TextField>

							<TextField
								required
								disabled
								onChange={(e) => onInputChange(e)}
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								variant="standard"

								label="Sequence Number"
								fullWidth={true}
								name="sequenceNumber"
								value={sequenceNumber || ""}
							></TextField>
							<TextField
								onChange={(e) => onInputChange(e)}
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								label="Field Acrobat Name"
								fullWidth={true}
								name="fieldAcrobatName"
								value={fieldAcrobatName || ""}
							></TextField>
						</DialogContent>
						<DialogActions>
							{/* <Button
								style={{
									backgroundColor: "#fff",
									color: "#000"
								}}
								variant="contained"
								onClick={handleClose}
							>
								Cancel
							</Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleClose}


							>
								Cancel
							</CustomButton>
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={addOrUpdateFeeReq}

							>
								Save
							</CustomButton>
							{/* <Button
								style={{
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={addOrUpdateFeeReq}
							>
								Save
							</Button> */}
						</DialogActions>
					</Dialog>
				</div>
			</Layout>

			{addOrUpdateFeeArray.status == "success" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{addOrUpdateFeeArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{addOrUpdateFeeArray.status == "failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{addOrUpdateFeeArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}
		</>
	);
}

export default AdminFeeMaster;
